import React, { useEffect, useState } from 'react'
import * as Icon from 'react-bootstrap-icons';
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import Index from '../../../../Assets/Images/Index';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ResponsivePagination from 'react-responsive-pagination';

import CurrencyFormat from 'react-currency-format';
import { dataValue } from '../../../../CommonReducer';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Form, Modal } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import Pricing from '../Pricing/Pricing';

export default function StationProfile() {
    const dataval = useSelector((state) => state.dataValue)
    const [descriptionData, setDescription] = useState([])
    const [chargerList, setChargerList] = useState([])
    const [value, setValue] = useState({})
    const [edit, setEdit] = useState(false)
    const [btnLoading, setbtnLoading] = useState(false)
    const [type, setType] = useState("")
    const [loader, setloader] = useState(true)
    const [hasMore, sethasMore] = useState(true)
    const [hasMore2, sethasMore2] = useState(true)
    const [chargerPage, setchargerPage] = useState(1)
    const [chargerPage2, setchargerPage2] = useState(1)
    const [chargerPage3, setchargerPage3] = useState(1)
    const [totalCharger, settotalCharger] = useState(0)
    const [checkedCharger, setcheckedCharger] = useState([])
    const [assinedCharger, setAssinedCharger] = useState([])
    const [activeData, setActiveData] = useState("")
    const [pricinglist, setpricinglist] = useState()
    const [error, seterror] = useState(false)
    const [count, setCount] = useState(1)
    const [count2, setCount2] = useState(1)
    const [show, setShow] = useState({
        show: false,
        type: "",
        main: ""
    });
    const [profileName, setProfileName] = useState("")
    const [profiles, setProfiles] = useState([
        { power: "", price: "", unit: "" }
    ])

    const [loading, setloading] = useState(true)


    const dispatch = useDispatch()
    let limit = 20
    const handleClose = () => {
        setShow({
            show: false,
            type: "",
            main: ""
        })
        setType("")
        setValue({})
        setActiveData("")
        setchargerPage(1)
        // setchargerPage2(1)
        setcheckedCharger([])
        setAssinedCharger([])
        sethasMore(true)
        sethasMore2(true)
        settotalCharger(0)
        setEdit(false)
        seterror(false)
        setbtnLoading(false)
        setProfileName("")
        setProfiles([
            { power: "", price: "", unit: "" }
        ])
    }
    const getList = (param) => {
        console.log("param", param)
        Api.GetApi(`${endPoints.CHARGERDESCRIPTIONS}${param}`).then((res) => {
            console.log("res", res)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                if (res.data.data.result && res.data.data.result.length > 0) {
                    const newData = res.data.data.result
                    setDescription(res.data.data.result)

                    let newCount = Math.ceil(parseInt(res.data.data?.totalCount?.count) / limit)
                    if (newCount !== 0) {
                        let items = [];
                        for (let number = 1; number <= newCount; number++) {
                            items.push(number);
                        }
                        setCount(items)
                    } else {
                        setCount(1)
                    }

                }
                handleClose()
            }
        })
    }
    const getChargerList = (id, param, type) => {
        Api.GetApi(`${endPoints.CHARGERLIST}/${type}/${id}${param}`).then((res) => {
            setloader(false)
            console.log("res CHARGERLIST", res)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                if (res.data.data.result && res.data.data.result.length > 0) {
                    const newData = res.data.data.result
                    if (chargerPage > 1) {
                        setChargerList(prevData => [...prevData, ...newData])
                    } else {
                        setChargerList(res.data.data.result)
                    }
                    settotalCharger(res.data.data.totalCount?.count)
                    if (newData.length === 0) {
                        sethasMore(false);
                    }
                } else {
                    setChargerList(res.data.data)
                }
            }
        })
    }

    // PRICING
    const getPricing = (param) => {
        Api.GetApi(`${endPoints.PRICING}${param}`).then(res => {
            console.log("pricinglist", res)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                setloading(false)
                if (res.data.data.pricing && res.data.data.pricing.result && res.data.data.pricing.result.length > 0) {
                    const newData = res.data.data.pricing.result
                    setpricinglist(newData)
                }
                let newCount = Math.ceil(parseInt(res.data.data.pricing?.totalCount?.count) / limit)
                if (newCount !== 0) {
                    let items = [];
                    for (let number = 1; number <= newCount; number++) {
                        items.push(number);
                    }
                    setCount2(items)
                } else {
                    setCount2(1)
                }


            }
        })
    }
    console.log("pricinglist", pricinglist)

    const updateFn = (api, url, body) => {
        api(url, body).then((res) => {
            console.log("res", res)
            setbtnLoading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
                setloading(false)
            } else {
                if (typeof res.data.data == "string") {
                    Api.Alert(res.data.data, "success")
                }
                getList(`?page=${chargerPage2}`)
                getPricing(`?page=${chargerPage3}`)
            }
        })
    }

    const showModal = (type, main) => {
        setShow({
            show: true,
            type: type,
            main: main
        })
    }

    const editModal = (data, type, mainType) => {
        setEdit(true)
        setActiveData(data)
        setType(mainType)
        if (type == "station") {
            setloader(true)
            getChargerList(data._id, "", mainType)
        } else if (type == "edit") {
            setProfileName(data.name)
        } else if (type == "add") {
            setValue({
                power: data.power,
                price: data.price,
                unit: data.unit
            })
        } else {
            setValue({
                description: data?.description
            })
        }
        setShow({
            show: true,
            type: type,
            main: mainType
        })
    }
    console.log("activeData", activeData)

    const handleInputchange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value })
    }

    const handleOnchange = (e, i) => {
        let arr = []
        profiles.map((x, index) => {
            if (index === i) {
                arr.push({ ...x, [e.target.name]: e.target.value })
            } else {
                arr.push(x)
            }
        })
        setProfiles(arr)
    }
    const handleEditchange = (e, i) => {
        let arr = []
        activeData.pricings.map((x, index) => {
            if (index === i) {
                arr.push({ ...x, [e.target.name]: e.target.value })
            } else {
                arr.push(x)
            }
        })
        setActiveData({ ...activeData, pricings: arr })
    }
    console.log("profiles", profiles)

    const loadMore = () => {
        console.log("load more")
        if (chargerList.length >= totalCharger) {
            sethasMore(false);
            return;
        } else {
            sethasMore(true);
            setTimeout(() => {
                setchargerPage(prevPage => prevPage + 1);
            }, 1000);
        }
    };


    const handleCheck = (e) => {
        if (e.target.checked) {
            let arr = [...checkedCharger]
            arr.push(e.target.value)
            setcheckedCharger(arr)
        } else {
            let arr = checkedCharger.filter((x) => x !== e.target.value)
            setcheckedCharger(arr)
        }
    }
    const handleAssignedCheck = (e) => {
        if (e.target.checked) {
            let arr = [...assinedCharger]
            arr.push(e.target.value)
            setAssinedCharger(arr)
        } else {
            let arr = assinedCharger.filter((x) => x !== e.target.value)
            setAssinedCharger(arr)
        }
    }

    const submitCharger = (submitType) => {
        let data = {}
        if (submitType == "assigned") {
            data = {
                charger_id: assinedCharger
            }
            updateFn(Api.PostApi, `${endPoints.REMOVECHARGERLIST}/${type}/${activeData?._id}`, data)
        } else {
            data = {
                charger_id: checkedCharger
            }
            updateFn(Api.PostApi, `${endPoints.ADDCHARGERLIST}/${type}/${activeData?._id}`, data)
        }
    }

    const handleSubmit = () => {
        if (show.type == "desc") {
            if (!value.description) {
                seterror(true)
            } else {
                setbtnLoading(true)
                seterror(false)
                let api = ""
                let body = {}
                if (edit) {
                    api = Api.PutApi
                    body = {
                        id: activeData?._id,
                        description: value.description
                    }
                } else {
                    api = Api.PostApi
                    body = {
                        description: value.description
                    }
                }
                updateFn(api, endPoints.CHARGERDESCRIPTION, body)
            }
        }
    }

    const handlePriceSubmit = () => {
        if (show.main == "price" && show.type == "add") {
            // if (!value.power || !value.price || !value.unit) {
            //     seterror(true)
            // } else {
            let arr = []
            profiles.map((opt, i) => {
                if (!opt.power || !opt.price || !opt.unit) {
                    arr.push({ ...opt, error: true })
                } else {
                    arr.push({ ...opt, error: false })
                }
            })
            setProfiles(arr)
            if (arr.filter((x) => x.error).length > 0) {
                seterror(true)
            } else {
                seterror(false)
                setbtnLoading(true)
                let api = "",
                    profilesArr = profiles.map((x) => {
                        return {
                            power: x.power,
                            price: Number(x.price),
                            unit: x.unit
                        }
                    })
                let body = {
                    name: profileName,
                    pricing: profilesArr
                }
                console.log("body", body)
                api = Api.PostApi
                updateFn(api, endPoints.PRICING_PROFILE, body)
            }
        }
    }
    const handlePriceEdit = () => {
        let arr = []
        activeData.pricings.filter((x) => !x.is_deleted).map((opt) => {
            if (!opt.power || !opt.price || !opt.unit) {
                arr.push({ ...opt, error: true })
            } else {
                arr.push({ ...opt, error: false })
            }
        })
        setActiveData({ ...activeData, pricings: arr })
        if (arr.filter((x) => x.error).length > 0) {
            seterror(true)
        } else {
            seterror(false)
            setbtnLoading(true)
            let profilesArr = activeData.pricings.map((x) => {
                return {
                    power: x.power,
                    price: Number(x.price),
                    unit: x.unit,
                    id: x._id,
                    is_deleted: x.is_deleted || false
                }
            })
            let body = {
                id: activeData?._id,
                name: profileName,
                is_active: activeData.is_active,
                is_default: activeData.is_default,
                pricing: profilesArr
            }
            console.log("body", body)
            updateFn(Api.PutApi, endPoints.PRICING_PROFILE, body)
        }
    }

    const onPageChangeFunction = (number) => {
        setchargerPage2(number)
    }
    const onPageChangeFunction2 = (number) => {
        setchargerPage3(number)
    }


    const makeDefault = (data, type, main, mainType) => {
        setEdit(true)
        setActiveData(data)
        setType(mainType)
        setShow({
            show: true,
            type: type,
            main: main
        })
    }

    const yesConfirm = () => {
        setbtnLoading(true)
        updateFn(Api.GetApi, `${endPoints.SETDEFAULT}/${type}/${activeData?._id}`, "")
    }
    const yesDelete = () => {
        setbtnLoading(true)
        if (type == "price") {
            updateFn(Api.DeleteApi, `${endPoints.PRICING_PROFILE}/${activeData?._id}`, "")
        } else {
            updateFn(Api.DeleteApi, `${endPoints.CHARGERDESCRIPTION}/${activeData?._id}`, "")
        }
    }

    useEffect(() => {
        getList("")
        getPricing("")
    }, [])

    const deleteField = (i) => {
        let arr = profiles.filter((x, index) => index !== i)
        setProfiles(arr)
    }
    const addField = () => {
        setProfiles([...profiles, { power: "", price: "", unit: "" }])
    }
    const deleteEditField = (i) => {
        let arr = []
        activeData.pricings.map((x, index) => {
            if (index == i) {
                arr.push({ ...x, is_deleted: true })
            } else {
                arr.push(x)
            }
        })
        setActiveData({ ...activeData, pricings: arr })
    }
    const addEditField = () => {
        setActiveData({ ...activeData, pricings: [...activeData.pricings, { power: "", price: "", unit: "", _id: null }] })
    }

    const handleDefaultCheck = (e) => {
        setActiveData({ ...activeData, is_default: e.target.checked })
    }

    const handleNameChange = (e) => {
        setProfileName(e.target.value)
    }

    useEffect(() => {
        if (show.type == "station" && activeData) {
            getChargerList(activeData._id, `?page=${chargerPage}`, type)
        }
    }, [chargerPage]);

    useEffect(() => {
        getList(`?page=${chargerPage2}`)
    }, [chargerPage2]);
    useEffect(() => {
        getPricing(`?page=${chargerPage3}`)
    }, [chargerPage3]);

    console.log("chargerPage2: ", chargerPage2)
    console.log("descriptionData: ", descriptionData)
    // console.log("checkedCharger: ", checkedCharger)

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Charging Station Profile</h1>
            </div>
            <div className="row profile">
                <div className="col-xxl-6">
                    <div className="card">
                        <div className="card-body  ">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className=" "><h5 className="card-title m-0">Description</h5></div>
                                <div className=" "> <button className="btn btn-sm btn-primary" disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && showModal("desc", "description")}>+ Add new</button></div>
                            </div>

                            {descriptionData && descriptionData.length > 0 ?
                                <>
                                    <div className='description_list table-responsive'>
                                        <table className="table dataTable">
                                            <thead>
                                                <tr>
                                                    {/* <th scope="col">#</th> */}
                                                    <th className='sorting' scope="col">Description</th>
                                                    <th scope="col" className='text-end'></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {descriptionData.map((opt, i) => {
                                                    let updInd = i + 1
                                                    return (
                                                        <tr key={i}>
                                                            {/* <td>{(params.page - 1) * 20 + updInd}</td> */}
                                                            <td width={"60%"} style={{ whiteSpace: "normal" }}>
                                                                {opt.is_default ?
                                                                    <Badge bg='success'>Default</Badge> : null
                                                                }
                                                                <p>{opt?.description || ""}</p>
                                                            </td>
                                                            <td className='text-end'>
                                                                {!opt.is_default ?
                                                                    <button className='btn btn-warning btn-sm me-2' disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && makeDefault(opt, "station", "default", "description")}>Make default</button>
                                                                    : null
                                                                }
                                                                <button className='btn btn-success btn-sm me-2' onClick={() => editModal(opt, "station", "description")}>Stations</button>
                                                                <button className="btn btn-sm btn-primary me-2" disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && editModal(opt, "desc", "description")}> <Icon.Pencil /> </button>
                                                                <button className="btn btn-sm btn-outline-danger" disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && editModal(opt, "delete", "description")}> <Icon.Trash3Fill /> </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    <ResponsivePagination
                                        current={chargerPage2}
                                        total={count.length}
                                        onPageChange={onPageChangeFunction}
                                        // disabled={params.page === count.length}
                                        // maxWidth={500}
                                        className={"pagination "}
                                    />
                                </>
                                :
                                <div className='text-center py-3'>
                                    <h5>No result found</h5>
                                </div>
                            }


                        </div>
                    </div>

                </div>

                <div className="col-xxl-6">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div className=" "><h5 className="card-title m-0">Pricing</h5></div>
                                <div className=" ">
                                    <button className="btn btn-sm btn-primary" disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && showModal("add", "price")}>+Add new</button>
                                </div>
                            </div>
                            {pricinglist && pricinglist.length > 0 ?
                                <>
                                    <div className='table-responsive'>
                                        <table className="table dataTable">
                                            <thead>
                                                <tr>
                                                    <th>Profile name</th>
                                                    <th>Pricing</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pricinglist && pricinglist.length > 0 && pricinglist.map((opt, indx) => {
                                                    return (
                                                        <tr className='' key={indx}>
                                                            <td width={"40%"}>
                                                                {opt.is_default ?
                                                                    <Badge bg='success'>Default</Badge> : null
                                                                }
                                                                <p>{opt.name}</p>
                                                            </td>
                                                            <td width={"30%"}>
                                                                <button className='btn btn-outline-danger btn-sm' onClick={() => editModal(opt, "view", "price")}>View pricing</button>
                                                            </td>
                                                            <td className='text-end'>
                                                                <button className='btn btn-success btn-sm me-2' onClick={() => editModal(opt, "station", "price")}>Stations</button>
                                                                <button className={`btn btn-text btn-sm btn-primary`} disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && editModal(opt, "edit", "price")}> <Icon.Pencil /> </button>
                                                                {!opt.is_default ?
                                                                    <button className="btn btn-sm btn-outline-danger ms-2" disabled={dataval?.isSupport} onClick={() => !dataval?.isSupport && editModal(opt, "delete", "price")}> <Icon.Trash3Fill /> </button>
                                                                    : null
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <ResponsivePagination
                                        current={chargerPage3}
                                        total={count2.length}
                                        onPageChange={onPageChangeFunction2}
                                        disabled={chargerPage3 === count2.length}
                                        // maxWidth={500}
                                        className={"pagination "}
                                    />

                                </>
                                :
                                <div className='text-center py-3'>
                                    <h5>No result found</h5>
                                </div>
                            }
                        </div>
                    </div>
                </div>

            </div>
            <Modal show={show.show} onHide={handleClose} size={show.main == "default" ? "md" : 'lg'} centered>
                {show.main !== "default" && show.type !== "delete" ?
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {show.type == "desc" ?
                                "Add description"
                                :
                                show.type == "station" ? "Charging stations"
                                    :
                                    show.main == "price" && show.type == "add" ?
                                        "Pricing"
                                        :
                                        show.type == "view" ?
                                            `Pricing (${activeData.name})`
                                            :
                                            ""
                            }
                        </Modal.Title>
                    </Modal.Header>
                    : null
                }
                <Modal.Body className='py-4'>
                    {show.main == "default" && show.type !== "delete" ?
                        <>
                            <div className='text-center my-4'>
                                <h4> Are you sure?</h4>
                                <h5>You want to make it default.</h5>
                            </div>
                            <Modal.Footer className='justify-content-center'>
                                <button className='btn btn-primary' disabled={btnLoading} onClick={btnLoading ? null : yesConfirm}>
                                    {btnLoading ? "Please wait" : "Yes"}
                                </button>
                                <button className='btn btn-outline-danger' onClick={handleClose}>Dismiss</button>
                            </Modal.Footer>
                        </>
                        :
                        show.main !== "default" && show.type == "delete" ?
                            <>
                                <div className='text-center my-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete.</h5>
                                </div>
                                <Modal.Footer className='justify-content-center'>
                                    <button className='btn btn-primary' disabled={btnLoading} onClick={btnLoading ? null : yesDelete}>
                                        {btnLoading ? "Please wait" : "Yes"}
                                    </button>
                                    <button className='btn btn-danger' onClick={handleClose}>Dismiss</button>
                                </Modal.Footer>
                            </>
                            :
                            <>
                                {show.type == "desc" ?
                                    <>
                                        <label htmlFor="" className="form-label">Enter description*</label>
                                        <textarea name='description' className="form-control" onChange={handleInputchange} value={value?.description} rows={10} />
                                        {error && !value.description ?
                                            <p style={{ color: "red" }}>Please enter description</p> : null
                                        }
                                        <Modal.Footer className='mt-4'>
                                            <button className='btn btn-primary' disabled={btnLoading} onClick={btnLoading ? null : handleSubmit}>
                                                {btnLoading ? "Please wait" : "Submit"}
                                            </button>
                                            <button className='btn btn-danger' onClick={handleClose}>Dismiss</button>
                                        </Modal.Footer>
                                    </>
                                    : null
                                }
                                {show.main == "price" && show.type == "add" ?
                                    <>
                                        <div className='row mb-3'>
                                            <div className='col-sm-5'>
                                                <label htmlFor="" className="form-label">Profile name</label>
                                                <input placeholder="" type="text" name="name" className="form-control" onChange={handleNameChange} value={profileName} />
                                                {error && !profileName ?
                                                    <p style={{ color: "red" }}><small>Please enter profile name</small></p> : null
                                                }
                                            </div>
                                        </div>
                                        {profiles.map((opt, i) => {
                                            return (
                                                <div className='row g-2 mb-2' key={i}>
                                                    <div className='col-sm-4 mb-2'>
                                                        <label htmlFor="" className="form-label">Power</label>
                                                        <input placeholder="" type="text" name="power" className="form-control" onChange={(e) => handleOnchange(e, i)} value={opt?.power} />
                                                        {opt.error && !opt.power ?
                                                            <p style={{ color: "red" }}><small>Please enter power</small></p> : null
                                                        }
                                                    </div>
                                                    <div className='col-sm-4 mb-2'>
                                                        <label htmlFor="" className="form-label">Price (RM)</label>
                                                        <input placeholder="" type="text" name="price" className="form-control" onChange={(e) => handleOnchange(e, i)} value={opt?.price} />
                                                        {opt.error && !opt.price ?
                                                            <p style={{ color: "red" }}><small>Please enter price</small></p> : null
                                                        }
                                                    </div>
                                                    <div className='col-sm-4 mb-2 d-flex align-items-start'>
                                                        <div className='w-100'>
                                                            <label htmlFor="" className="form-label">Unit</label>
                                                            <input placeholder="" type="text" name="unit" className="form-control" onChange={(e) => handleOnchange(e, i)} value={opt?.unit} />
                                                            {opt.error && !opt.unit ?
                                                                <p style={{ color: "red" }}><small>Please enter unit</small></p> : null
                                                            }
                                                        </div>
                                                        <button className='btn btn-sm btn-outline-danger ms-2' style={{ fontSize: "24px", lineHeight: "normal", paddingBlock: 0, marginTop: "29px" }} onClick={() => profiles.length > 1 && deleteField(i)} disabled={profiles.length > 1 ? false : true}>
                                                            <Icon.X />
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div className='text-end mb-4 mt-2'>
                                            <button className='btn btn-sm btn-primary' onClick={addField}>
                                                + Add new
                                            </button>
                                        </div>
                                        <Modal.Footer>
                                            <button className='btn btn-primary' disabled={btnLoading} onClick={btnLoading ? null : handlePriceSubmit}>
                                                {btnLoading ? "Please wait" : "Submit"}
                                            </button>
                                            <button className='btn btn-outline-danger' onClick={handleClose}>Dismiss</button>
                                        </Modal.Footer>
                                    </>
                                    : null
                                }
                                {show.main == "price" && show.type == "view" ?
                                    <>
                                        {activeData && activeData.pricings.length > 0 ?
                                            <>
                                                <div className='table-responsive'>
                                                    <table className="table dataTable">
                                                        <thead>
                                                            <tr>
                                                                <th>Power</th>
                                                                <th>Price</th>
                                                                <th>Unit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {activeData && activeData.pricings.length > 0 && activeData.pricings.map((opt, indx) => {
                                                                return (
                                                                    <tr className='' key={indx}>
                                                                        <td>
                                                                            <p>{opt.power}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p>{opt.price}</p>
                                                                        </td>
                                                                        <td>
                                                                            <p>{opt.unit}</p>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                            :
                                            <div className='text-center py-3'>
                                                <h5>No result found</h5>
                                            </div>
                                        }
                                    </>
                                    : null
                                }
                                {show.main == "price" && show.type == "edit" ?
                                    <>
                                        <div className='row mb-3 g-5 align-items-end'>
                                            <div className='col-sm-6'>
                                                <label htmlFor="" className="form-label">Profile name</label>
                                                <input placeholder="" type="text" name="name" className="form-control" onChange={handleNameChange} value={profileName} />
                                                {error && !profileName ?
                                                    <p style={{ color: "red" }}><small>Please enter profile name</small></p> : null
                                                }
                                            </div>
                                            <div className='col-sm-6'>
                                                <Form.Check
                                                    type={"checkbox"}
                                                    id={"is_default"}
                                                    label={"Default"}
                                                    checked={activeData.is_default}
                                                    onChange={handleDefaultCheck}
                                                />
                                            </div>
                                        </div>
                                        {activeData.pricings.filter((x) => !(x?.is_deleted)).map((opt, i) => {
                                            return (
                                                <div className='row g-2 mb-2' key={i}>
                                                    <div className='col-sm-4 mb-2'>
                                                        <label htmlFor="" className="form-label">Power</label>
                                                        <input placeholder="" type="text" name="power" className="form-control" onChange={(e) => handleEditchange(e, i)} value={opt?.power} />
                                                        {opt.error && !opt.power ?
                                                            <p style={{ color: "red" }}><small>Please enter power</small></p> : null
                                                        }
                                                    </div>
                                                    <div className='col-sm-4 mb-2'>
                                                        <label htmlFor="" className="form-label">Price (RM)</label>
                                                        <input placeholder="" type="text" name="price" className="form-control" onChange={(e) => handleEditchange(e, i)} value={opt?.price} />
                                                        {opt.error && !opt.price ?
                                                            <p style={{ color: "red" }}><small>Please enter price</small></p> : null
                                                        }
                                                    </div>
                                                    <div className='col-sm-4 mb-2 d-flex align-items-start'>
                                                        <div className='w-100'>
                                                            <label htmlFor="" className="form-label">Unit</label>
                                                            <input placeholder="" type="text" name="unit" className="form-control" onChange={(e) => handleEditchange(e, i)} value={opt?.unit} />
                                                            {opt.error && !opt.unit ?
                                                                <p style={{ color: "red" }}><small>Please enter unit</small></p> : null
                                                            }
                                                        </div>
                                                        <button className='btn btn-sm btn-outline-danger ms-2' style={{ fontSize: "24px", lineHeight: "normal", paddingBlock: 0, marginTop: "29px" }} onClick={() => activeData.pricings.length > 1 && deleteEditField(i)} disabled={activeData.pricings.length > 1 ? false : true}>
                                                            <Icon.X />
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div className='text-end mb-4 mt-2'>
                                            <button className='btn btn-sm btn-primary' onClick={addEditField}>
                                                + Add new
                                            </button>
                                        </div>
                                        <Modal.Footer>
                                            <button className='btn btn-primary' disabled={btnLoading} onClick={btnLoading ? null : handlePriceEdit}>
                                                {btnLoading ? "Please wait" : "Submit"}
                                            </button>
                                            <button className='btn btn-outline-danger' onClick={handleClose}>Dismiss</button>
                                        </Modal.Footer>
                                    </>
                                    : null
                                }
                                {show.type == "station" ?
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <h6>Assigned Chargers</h6>
                                            {loader ? "Loading..." : activeData.assign_charger.length > 0 ?
                                                <>
                                                    <div className='chargers_assignmentOverFlow'>
                                                        <InfiniteScroll
                                                            dataLength={activeData.assign_charger.length}
                                                            next={loadMore}
                                                            hasMore={hasMore}
                                                            loader={<p><strong>Loading...</strong></p>}
                                                            height={340}
                                                        >
                                                            {activeData.assign_charger.map((opt, i) => {
                                                                return (
                                                                    <div key={opt?._id}>
                                                                        {dataval?.isSupport ?
                                                                            <p className='mb-1'>{opt?.charging_station?.endpoint || ""}</p>
                                                                            :
                                                                            <Form.Check
                                                                                type={"checkbox"}
                                                                                id={opt?._id}
                                                                                label={opt?.charging_station?.endpoint || ""}
                                                                                value={opt?.charging_station?._id}
                                                                                onChange={handleAssignedCheck}
                                                                            />
                                                                        }
                                                                    </div>
                                                                )
                                                            })}
                                                        </InfiniteScroll>
                                                        {assinedCharger.length ?
                                                            <Modal.Footer className='justify-content-start ps-0'>
                                                                <button className='btn btn-danger' disabled={btnLoading} onClick={btnLoading ? null : () => submitCharger("assigned")}>
                                                                    {btnLoading ? "Please wait" : "Remove"}
                                                                </button>
                                                            </Modal.Footer>
                                                            : null
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <h6 className='py-3'>No charger assigned</h6>
                                            }
                                        </div>
                                        <div className='col-md-6'>
                                            <h6>Available Chargers</h6>
                                            {loader ? "Loading..." : chargerList.length > 0 ?
                                                <>
                                                    <div className='chargers_assignmentOverFlow'>
                                                        <InfiniteScroll
                                                            dataLength={chargerList.length}
                                                            next={loadMore}
                                                            hasMore={hasMore}
                                                            loader={<p><strong>Loading...</strong></p>}
                                                            height={340}
                                                        >
                                                            {chargerList.map((opt, i) => {
                                                                return (
                                                                    <div key={opt?._id}>
                                                                        {dataval?.isSupport ?
                                                                            <p className='mb-1'>{opt?.endpoint || ""}</p>
                                                                            :
                                                                            <Form.Check
                                                                                type={"checkbox"}
                                                                                id={opt?._id}
                                                                                label={opt?.endpoint || ""}
                                                                                value={opt?._id}
                                                                                onChange={handleCheck}
                                                                            />
                                                                        }
                                                                    </div>
                                                                )
                                                            })}
                                                        </InfiniteScroll>
                                                        {checkedCharger.length ?
                                                            <Modal.Footer>
                                                                <button className='btn btn-primary' disabled={btnLoading} onClick={btnLoading ? null : () => submitCharger("available")}>
                                                                    {btnLoading ? "Please wait" : "Assign"}
                                                                </button>
                                                            </Modal.Footer>
                                                            : null
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <h6 className='py-3'>No charger available</h6>
                                            }
                                        </div>
                                    </div>
                                    : null
                                }
                            </>
                    }
                </Modal.Body>
            </Modal>

        </main >
    )
}
